import gql from 'graphql-tag';

export default gql`
  mutation deleteArtwork($input: DeleteArtworkInput!) {
    deleteArtwork(input: $input) {
      id
    }
  }
`;
